import React, { Component, Fragment } from 'react';

import Button from '../../artzu-ui/src/Button';

import SubmitImage from './SubmitImage';
import PreviewImage from './PreviewImage';
import Footer from './FooterFixed';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

class UploadEligibility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      src: '',
      errors: '',
      loading: false,
    };
  }

  toggleLoaded = () => this.setState({ loading: !this.state.loading });

  updateSrc = src => this.setState({ src });

  onNextClick = () => this.props.incrementStep();

  onBackClick = () => this.props.decrementStep();

  render() {
    const { currentUser, currentStep, refetch, title } = this.props;
    const { src, loading } = this.state;

    return (
      <Fragment>
        <ScrollLock>
          <EncourageScroll className="apply__eligibility">
            <div className="apply__eligibility--container">
              <div className="apply__body--title"> {title}</div>
              <div className="apply__eligibility--content">
                {' '}
                <div>
                  {' '}
                  If you are a Canadian citizen, one of the following would work: passport, citizenship card, birth
                  certificate or SIN card.
                </div>
                <br />
                <div>
                  {' '}
                  If you are not a Canadian citizen, a permanent residency card, SIN card that does not start with “9”
                  or work permit.
                </div>
                <br />
                <div>
                  {' '}
                  Text must be <b>clear</b> and <b>readable.</b>{' '}
                </div>
                <br />
                <div> *Expired documents are not valid. </div>
              </div>
              <div className="apply__eligibility--upload">
                <PreviewImage
                  image={currentUser ? currentUser.employmentEligibilityImage : null}
                  src={src}
                  loading={loading}
                  category="eligibility"
                />
                <div className="apply__eligibility--buttons">
                  {currentUser.employmentEligibilityImage || src ? (
                    <Button
                      fullWidth
                      label="Edit Image"
                      onClick={() => {
                        const input = document.getElementById('edit_photo');
                        input.click();
                      }}
                    />
                  ) : null}
                  <div className="hide">
                    <Button label="Edit" />
                  </div>
                  <SubmitImage
                    toggleLoaded={this.toggleLoaded}
                    type="employment_eligibility_image"
                    refetch={refetch}
                    updateSrc={this.updateSrc}
                  />
                </div>
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          active={(currentUser.employmentEligibilityImage || src) && !loading}
          back
          label="Next"
          onNextClick={this.onNextClick}
          onBackClick={this.onBackClick}
        />
      </Fragment>
    );
  }
}

export default UploadEligibility;



// WEBPACK FOOTER //
// ./src/components/TorontoApply/UploadEligibility.js